var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c("datepicker", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'",
          },
        ],
        ref: "datepicker",
        staticClass: "flex-1 items-center",
        attrs: { id: "days", name: _vm.name, format: "yyyy-MM-dd" },
        on: { selected: _vm.dateSelected },
        model: {
          value: _vm.selector.day,
          callback: function ($$v) {
            _vm.$set(_vm.selector, "day", $$v)
          },
          expression: "selector.day",
        },
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.removeDay.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                width: "35",
                height: "35",
                viewBox: "0 0 100 100",
              },
            },
            [
              _c("g", [
                _c(
                  "g",
                  {
                    staticStyle: { fill: "#000000" },
                    attrs: {
                      transform:
                        "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticStyle: { "enable-background": "new 0 0 100 100" },
                        attrs: {
                          fill: "#000000",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          version: "1.1",
                          x: "0px",
                          y: "0px",
                          viewBox: "0 0 100 100",
                          "xml:space": "preserve",
                        },
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "33.1",
                            y: "38.8",
                            width: "5.6",
                            height: "45",
                          },
                        }),
                        _c("rect", {
                          attrs: {
                            x: "47.2",
                            y: "38.8",
                            width: "5.6",
                            height: "45",
                          },
                        }),
                        _c("rect", {
                          attrs: {
                            x: "61.2",
                            y: "38.8",
                            width: "5.6",
                            height: "45",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M86.6,16.2H66.9V5H33.1v11.2H13.4v16.9H19V95h61.9V33.1h5.6L86.6,16.2L86.6,16.2z M38.8,10.6h22.5v5.6H38.8V10.6z   M19.1,21.9h14.1H67h14.1v5.6h-62V21.9z M75.3,89.4H24.7V33.1h50.6V89.4z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }